// "oh yea, types are so much fun"
// generic reducer copied from redux.js.org

export interface ITypeHaver { type: string };
export type Action = {
	[key: string]: any
};

export function createReducer<TState>(
	initialState: TState,
	handlers: { [type: string]: (state: TState, action: ITypeHaver) => TState }) {

	return function reducer(state: TState = initialState, action: ITypeHaver) {
		if (handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](state, action);
		} else {
			return state;
		}
	}
}